import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import * as Sentry from "@sentry/vue";

import {
    faWhatsapp,
    faFacebook,
    faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import {
    faChevronDown,
    faCalendarDay,
    faGasPump,
    faCircleInfo,
    faGauge,
    faEngine,
    faLeaf,
    faSwatchbook,
    faPhone,
    faEnvelope,
    faCarBuilding,
    faChevronRight,
    faEye,
    faXmark,
    faChevronLeft,
    faArrowLeft,
    faArrowRight,
    faTriangleExclamation,
    faMap,
    faBars,
    faMagnifyingGlass,

} from "@fortawesome/pro-regular-svg-icons";

import {
    faFilter as faFilterSolid,
    faFilterCircleXmark as faFilterCircleXmarkSolid,
    faPhoneVolume as fasPhoneVolumeSolid,
    faCarBuilding as fasCarBuildingSolid,
    faGarageOpen as fasGarageOpenSolid,
    faCarpool as fasCarpoolSoli,
    faCalendarWeek as fasCalendarWeekSolid,
    faGaugeLow as fasGaugeLowSolid,
    faCarSide as fasCarSideSolid,
    faTag as fasTagSolid,
    faChargingStation as fasChargingStationSolid,
    faGauge as fasGaugeSolid,
    faGaugeHigh as fasGaugeHighSolid,
    faGasPump as fasGasPumpSolid,
    faHandHoldingCircleDollar as fasHandHoldingCircleDollarSolid,
    faSpinner as fasSpinnerSolid,
    faCarWrench as fasCarWrenchSolid,
    faCarBattery as fasCarBatterySolid,
} from "@fortawesome/pro-solid-svg-icons";

import Layout from "./Pages/Layout.vue";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => {
        const pages = import.meta.glob(
            ["./Pages/*.vue", "./Pages/**/*.vue", "./Pages/**/**/*.vue"],
            { eager: true }
        );
        let page = pages[`./Pages/${name}.vue`];
        page.default.layout = Layout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) }).use(plugin);

        library.add(
            faWhatsapp,
            faFacebook,
            faInstagram,
            faChevronDown,
            faFilterSolid,
            faFilterCircleXmarkSolid,
            faCalendarDay,
            faGasPump,
            faCircleInfo,
            faGauge,
            faEngine,
            faLeaf,
            faSwatchbook,
            faPhone,
            faEnvelope,
            faCarBuilding,
            faChevronRight,
            faEye,
            faXmark,
            faChevronLeft,
            faArrowLeft,
            faArrowRight,
            faTriangleExclamation,
            faMap,
            faBars,
            faMagnifyingGlass,
            fasPhoneVolumeSolid,
            fasCarBuildingSolid,
            fasGarageOpenSolid,
            fasCarpoolSoli,
            fasCalendarWeekSolid,
            fasGaugeLowSolid,
            fasCarSideSolid,
            fasTagSolid,
            fasChargingStationSolid,
            fasGaugeSolid,
            fasGaugeHighSolid,
            fasGasPumpSolid,
            fasHandHoldingCircleDollarSolid,
            fasSpinnerSolid,
            fasCarWrenchSolid,
            fasCarBatterySolid
        );

        Sentry.init({
            app,
            dsn: "https://7182a9223616ae5e0920b7e814778a3c@o4508357877039104.ingest.de.sentry.io/4510107458011216",
            integrations: [
          ],
        });

        app.component("font-awesome-icon", FontAwesomeIcon);
        app.use(autoAnimatePlugin);

        app.mount(el);
    },
});
